import { useReducer } from 'react';

const UPDATE_WAREHOUSE = 'UPDATE_WAREHOUSE';
const UPDATE_MARKETPLACES = 'UPDATE_MARKETPLACES';

export const updateWarehouseAction = (payload) => ({
  type: UPDATE_WAREHOUSE,
  payload,
});
export const updateMarketplacesAction = (payload) => ({
  type: UPDATE_MARKETPLACES,
  payload,
});

export default function useEditUserReducer(initialState) {
  const reducer = (state, action) => {
    if (action.type === UPDATE_WAREHOUSE) {
      return {
        ...state,
        warehouse_id: action.payload,
      };
    }

    if (action.type === UPDATE_MARKETPLACES) {
      return {
        ...state,
        marketplace_ids: action.payload,
      };
    }

    return state;
  };

  const initializer = (initialState) => initialState;

  return useReducer(reducer, initialState, initializer);
}
